/**
 * @generated SignedSource<<a012d1f3a72b0879c8e1fb1e6afe2a83>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeEditMainFields_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CitySelect_data" | "CountrySelect_data" | "PoiSelect_data" | "RegionSelect_data">;
  readonly " $fragmentType": "WhatToSeeEditMainFields_data";
};
export type WhatToSeeEditMainFields_data$key = {
  readonly " $data"?: WhatToSeeEditMainFields_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditMainFields_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeEditMainFields_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CountrySelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RegionSelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CitySelect_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PoiSelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "565e61d3eaa8c40584807075418807d2";

export default node;
